import { apiClient } from '../../core/api/client';
import type { SkinAsset, SkinCatalog, SkinManifest } from './types';

export function resolveAppearanceAssetUrl(url: string): string {
  if (url.startsWith('/api/')) return `${apiClient.baseUrl}${url.slice('/api'.length)}`;
  return url;
}

export async function fetchSkinCatalog(): Promise<SkinCatalog> {
  return apiClient.get<SkinCatalog>('/v1/appearance/catalog');
}

export async function fetchSkinManifest(skinId: string, version: number): Promise<SkinManifest> {
  return apiClient.get<SkinManifest>(
    `/v1/appearance/skins/${encodeURIComponent(skinId)}/versions/${String(version)}`,
  );
}

async function blobDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '');
    reader.onerror = () => reject(reader.error ?? new Error('无法读取皮肤素材'));
    reader.readAsDataURL(blob);
  });
}

export async function downloadSkinAssets(
  assets: readonly SkinAsset[],
  signal?: AbortSignal,
): Promise<Record<string, string>> {
  const result: Record<string, string> = {};
  for (const asset of assets) {
    const response = await fetch(resolveAppearanceAssetUrl(asset.url), { credentials: 'include', signal });
    if (!response.ok) throw new Error(`皮肤素材加载失败（${response.status}）`);
    result[asset.id] = await blobDataUrl(await response.blob());
  }
  return result;
}

export function wallpaperFromAssets(manifest: SkinManifest, assets: Record<string, string>): string | null {
  const asset = manifest.assets.find((entry) => entry.kind === 'wallpaper');
  return asset ? assets[asset.id] ?? null : null;
}

